import Vue from 'vue'
import VueRouter from 'vue-router'
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import VModal from 'vue-js-modal'

import Home from './views/Home.vue'
import Office from './views/offices/OfficeList'
import Login from './views/auth/Login'
import Logout from './views/auth/Logout'
import Permission from './views/permissions/Permissions';
import User from './views/users/Users'
import Route from './views/routes/Routes'
import RouteDetail from './views/routes/RouteDetails'
import RouteDetail2 from './views/routes/RouteDetails2'
import Record from './views/records/Records'
import RecordFilings from './views/records/RecordFilings'
import RecordCategories from './views/records/RecordCategories'
import RecordFolders from './views/records/RecordFolders'
import RouteAssigned from './views/routes/RouteAssigned'
// import Positions from './views/positions/Positions'
// import Actions from './views/actions/Actions'
import Document from './views/documents/Documents';
import RouteRecordRequest from './views/records/RouteRecordRequests'
import Error403 from "./views/common/Error403";
import PDFViewer from './components/common/PdfViewer';
import Dashboard from './views/dashboard/Dashboard'
Vue.use(VueRouter);
Vue.use(DatetimePicker);
Vue.use(VModal, { dynamicDefault: { draggable: true, resizable: true } });
Vue.filter('two_digits', (value) => {
    if (value < 0) {
        return '00';
    }
    if (value.toString().length <= 1) {
        return `0${value}`;
    }
    return value;
});

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/offices',
            name: 'offices',
            component: Office,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/permissions',
            name: 'permissions',
            component: Permission,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/users',
            name: 'users',
            component: User,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/routes',
            name: 'routes',
            component: Route,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/routes/:id',
            name: 'route_details',
            component: RouteDetail2,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/routes2/:id',
            name: 'route_details2',
            component: RouteDetail,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/routes/assigned/:id',
            name: 'routes_assigned',
            component: RouteAssigned,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/documents',
            name: 'documents',
            component: Document,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/records',
            name: 'records',
            component: Record,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/records/route-requests',
            name: 'record_requests',
            component: RouteRecordRequest,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/records/filings/:id',
            name: 'records_filings',
            component: RecordFilings,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/records/categories/:id',
            name: 'records_categories',
            component: RecordCategories,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/records/folders/:id',
            name: 'records_folders',
            component: RecordFolders,
            meta: {
                requiresAuth: true
            },
        },
        // {
        //     path: '/actions',
        //     name: 'actions',
        //     component: Actions,
        //     meta: {
        //         requiresAuth: true
        //     },
        // },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresVisitor: true
            }
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout
        },
        {
            path: '/403',
            name: '403',
            component: Error403
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            redirect: '/routes',
            meta: {
                requiresAuth: true
            },
        },
		{
			path: '/pdf/viewer',
			name: 'pdf viewer',
			component: PDFViewer
		}
    ]
})